import useIsRole from './useIsRole'
import useIsSuperAdmin from './useIsSuperAdmin'

export default () => {
  const isAdmin = useIsRole('admin')
  const isSuperAdmin = useIsSuperAdmin()
  return isAdmin || isSuperAdmin
}
